import { render, staticRenderFns } from "./BloodGroup.vue?vue&type=template&id=45d7a7b5"
import script from "./BloodGroup.vue?vue&type=script&lang=js"
export * from "./BloodGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports